import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';
import { TimesheetDepotsQuery } from '../model/query/timesheet-depots-query';
import { TimesheetQuery } from '../model/query/timesheet-query';
import { Query } from '../model/query/query';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for communicating with the Timesheet API endpoint.
@Injectable()
export class TimesheetEndpointService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) {}

  TimesheetDepotsQuery(queryData: TimesheetDepotsQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.TimesheetDepotsQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  TimesheetQuery(queryData: TimesheetQuery): Observable<any> {
    const data = {
      QueryData: JSON.stringify(queryData),
      QueryType: 'Cads.SmartScaffolder.Hub.Business.Query.TimesheetQuery'
    };

    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = { headers: headers };

    return this.http.post(`${this.settingsService.getApiServiceBaseUrl()}webQuery`, data, options);
  }

  Get(timesheetId: string): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const headers = new HttpHeaders(
    {
      'Content-Type': 'application/json; charset=utf-8',
      'Authorization': `Bearer ${token}`
    });
    const options = {
      headers: headers,
    };

    return this.http.request(
      'GET',
      this.settingsService.getApiServiceBaseUrl() + 'Timesheet/' + timesheetId,
      options);
  }
}
